import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * External dependencies
 */
import { useContext, useEffect, useMemo, useState } from 'react';
import useFetch from '../hooks/useFetch';
import useMap from '../hooks/useMap';
import useWindowSize from '../hooks/useWindowSize';
import { SET_FILTERED_POSTS, SET_POSTS, store } from '../state/state';
import { latitudeSort } from './ExplorerMap';
import IconSprite from './IconSprite';
import Map from './Map';
import MapToggle from './MapToggle';
import MapUI from './MapUI';
import VisitorInfoCard from './VisitorInfoCard';
import { motion } from 'framer-motion';
import Spinner from './Spinner';
const url = `${window.mainSiteData.root}scenic-rim/v2/centres?`;
const VisitorInfoCentres = () => {
    const { height } = useWindowSize();
    const { ref, map, loaded: mapLoaded } = useMap();
    const [loading, setLoading] = useState(false);
    const [route, setRoute] = useState(null);
    const globalState = useContext(store);
    const { state, dispatch } = globalState;
    const { filteredPosts = [] } = state;
    const visibleFilteredPosts = useMemo(() => {
        return latitudeSort(filteredPosts || []);
    }, [filteredPosts]);
    const filterParams = useMemo(() => ({
        nonce: window.mainSiteData.nonce
    }), []);
    // Fetch centres
    const { data, error } = useFetch(url + new URLSearchParams(filterParams), {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            'X-WP-Nonce': window.mainSiteData.nonce
        },
    });
    // Update filtered posts when posts are stored in state
    useEffect(() => {
        dispatch({
            type: SET_FILTERED_POSTS,
            ...state,
            filteredPosts: state.posts
        });
    }, [state.posts, dispatch]);
    // Update fetched centres in state
    useEffect(() => {
        setLoading(true);
        if (!error && data) {
            dispatch({
                type: SET_POSTS,
                posts: data?.posts || []
            });
            setTimeout(() => {
                setLoading(false);
            }, 300);
        }
    }, [data]);
    // Handle map data
    useEffect(() => {
        if (!visibleFilteredPosts.length)
            return;
        setRoute({
            path: 'places',
            meta: {
                title: 'Places to visit',
                variant: 'blue',
                homeCard: false,
                layer: {
                    title: 'Title',
                    intro: 'Intro',
                    icon: 'mountain',
                    posts: visibleFilteredPosts
                },
            },
        });
    }, [visibleFilteredPosts, setRoute]);
    const mapStyle = state.showMap
        ? { opacity: 1, visibility: 'visible', height: 'auto' }
        : { opacity: 0, visibility: 'hidden', height: 0 };
    return (_jsxs(_Fragment, { children: [_jsx(IconSprite, {}), _jsxs("section", { className: "space-y-8", children: [!loading && (_jsx("section", { className: "post-filters corridor space-y-8", children: _jsxs("div", { className: "flex flex-col space-y-6 tablet-portrait:flex-row tablet-portrait:items-center tablet-portrait:justify-between tablet-portrait:space-y-0", children: [_jsxs("p", { className: "font-semibold leading-tighter", children: [state.posts.length, " Visitor Information Centres for your convenience"] }), _jsx(MapToggle, {})] }) })), _jsxs(_Fragment, { children: [_jsx("div", { style: mapStyle, children: _jsxs("div", { className: "relative w-full bg-grey-100", style: { height: height + 'px' }, children: [_jsx(Map, { mapRef: ref, loaded: mapLoaded }), mapLoaded && route && _jsx(MapUI, { map: map, routes: [route] })] }) }), loading ? (_jsx(motion.div, { exit: { opacity: 0, height: 0 }, className: "absolute inset-0 flex items-center justify-center h-full pointer-events-none", children: _jsx(Spinner, { size: "lg", color: "gold" }) })) : (!state.showMap &&
                                _jsx("div", { className: `corridor transition-all space-y-12 tablet-landscape:space-y-14 desktop:space-y-16`, children: visibleFilteredPosts.map((post) => (_jsx("div", { className: "pt-12 border-t border-grey-100 tablet-landscape:pt-14 desktop:pt-16", children: _jsx(VisitorInfoCard, { title: post.title, address: post.address, description: post.description, email: post?.email, phone: post?.phone, openingTimes: post.openingTimes, thumbnail: post.image }) }, post.id))) }))] })] })] }));
};
export default VisitorInfoCentres;
